import Column from '@app/components/layout/Column'
import { useLanguage } from '@i18n/useLanguage'
import { i18n } from '@i18n/index'
import { MegaMenuLinks } from '../blocks/common'
import { MegaMenuMobileItem } from '../blocks/MegaMenuMobileItem'
import {
  faHouseBuilding,
  faUsers,
  faLocationDot,
  faMapLocationDot,
  faShapes,
  faUserTie,
} from '@fortawesome/pro-solid-svg-icons'

export type FindMenuProps = {
  onClose: () => void
}

export const FindMenu = ({ onClose }: FindMenuProps) => {
  const [language] = useLanguage()
  const translations = i18n.languages[language].app.nav.megaMenu.findMenu

  return (
    <Column gap="1rem" style={{ alignSelf: 'stretch', flexGrow: 1 }}>
      <MegaMenuMobileItem
        to={MegaMenuLinks.discoverInitiatives}
        onClick={onClose}
        icon={faHouseBuilding}
        label={translations.initiatives.label}
        description={translations.initiatives.description}
        backgroundColor="var(--shades-pink-200)"
      />
      <MegaMenuMobileItem
        to={MegaMenuLinks.discoverInitiativesLiving}
        onClick={onClose}
        icon={faUsers}
        label={translations.livingGroups.label}
        description={translations.livingGroups.description}
        backgroundColor="var(--shades-yellow-300)"
      />
      <MegaMenuMobileItem
        to={MegaMenuLinks.discoverPlots}
        onClick={onClose}
        icon={faLocationDot}
        label={translations.plots.label}
        description={translations.plots.description}
        backgroundColor="var(--shades-blue-100)"
      />
      <MegaMenuMobileItem
        to={MegaMenuLinks.regions}
        onClick={onClose}
        icon={faMapLocationDot}
        label={translations.region.label}
        description={translations.region.description}
        backgroundColor="var(--shades-red-200)"
      />
      <MegaMenuMobileItem
        to={MegaMenuLinks.housingForms}
        onClick={onClose}
        icon={faShapes}
        label={translations.housingForms.label}
        description={translations.housingForms.description}
        backgroundColor="var(--shades-beige-100)"
      />
      <MegaMenuMobileItem
        to={MegaMenuLinks.discoverServiceProviders}
        onClick={onClose}
        icon={faUserTie}
        label={translations.experts.label}
        description={translations.experts.description}
        backgroundColor="#C5F1D0"
      />
    </Column>
  )
}
